import { fromJS, List } from 'immutable';
import Actions from 'flow/actions';
import { KeyboardShortcut } from 'flow/types/KeyboardShortcut';
import { TypedMap } from 'flow/types/TypedMap';

type KeyboardShortcutsState = List<TypedMap<KeyboardShortcut>>;

const initialState: KeyboardShortcutsState = List();

export const keyboardShortcutsReducer = (
    state = initialState,
    action: {
        type: string;
        data?: KeyboardShortcut[];
        singleData?: KeyboardShortcut;
    },
): KeyboardShortcutsState => {
    switch (action?.type) {
        case Actions.RESULT_KEYBOARD_SHORTCUTS: {
            return fromJS(action.data || []);
        }
        case Actions.CLEAR_STATE: {
            return initialState;
        }
        default:
            return state;
    }
};

export default keyboardShortcutsReducer;
